// File upload constants
export const MAX_FILE_SIZE = 5 * 1024 * 1024 * 1024; // 5GB
export const MULTIPART_THRESHOLD = 100 * 1024 * 1024; // 100MB
export const ALLOWED_AUDIO_TYPES = [
  'audio/wav',
  'audio/wave',
  'audio/x-wav',
  'audio/mpeg',
  'audio/mp3',
  'audio/flac',
  'audio/x-flac',
  'audio/aac',
  'audio/ogg',
  'audio/webm',
  'audio/m4a',
  'audio/x-m4a'
];

// Storage tier constants
export const STORAGE_TIERS = {
  UPLOAD: 'upload' as const,
  ARCHIVE: 'archive' as const
};

// Time constants
export const ARCHIVAL_THRESHOLD_DAYS = 60;
export const DELETION_ELIGIBILITY_DAYS = 120;
export const NOTIFICATION_THRESHOLD_DAYS = 7;

// URL expiration times
export const UPLOAD_URL_EXPIRY_MINUTES = 15;
export const DOWNLOAD_URL_EXPIRY_HOURS = 1;

// Pagination
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 100;

// Query keys for React Query
export const QUERY_KEYS = {
  FOLDERS: 'folders',
  FILES: 'files',
  USERS: 'users',
  BUDGET_DASHBOARD: 'budget-dashboard',
  USER_COSTS: 'user-costs'
} as const;